module.exports = __webpack_public_path__ + "media/store/fonts/BeausiteClassic-Bold_web-cf15f3850e82e057c99aa9b4c7e9e75f.woff";